import React, { useEffect } from "react";
import "./couponsidebar.scss";
import { useDispatch, useSelector } from "react-redux";
import MultiBannerAdSlide from "routes/home/MultiBannerAd/MultiBannerAdSlide";
import { updateCouponCategoryIds } from 'redux/actions';
import { useGetCouponList } from 'hooks/useGetCouponList';
const ALLOW_MULTI_SELECT = false

const CouponListingPageSidebar = ({ isMobileView, setIsShowMobileFilter, bannerAd }) => {
  const {categoryIds} = useSelector(({coupon}) => coupon)
  const { isLoading: couponDataLoading } = useGetCouponList()

  const dispatch = useDispatch()
  const { couponCategoriesData } = useSelector(({coupon}) => coupon)

  useEffect(() => {
    if (ALLOW_MULTI_SELECT) {
      if (categoryIds?.length === 1 && categoryIds[0] === "0" && couponCategoriesData?.length > 0) {
        dispatch(updateCouponCategoryIds([...couponCategoriesData?.map(c => c.product_category_id), "0"]));
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [couponCategoriesData])

  const onChangeSelection = id => {
    if (!ALLOW_MULTI_SELECT) {
      dispatch(updateCouponCategoryIds([id]));
      setIsShowMobileFilter && setIsShowMobileFilter();
      return
    }

    let selectedCategories
    if (id === "0") {
      if (categoryIds.includes("0")) {
        selectedCategories = [];
      } else {
        selectedCategories = [...couponCategoriesData?.map(c => c.product_category_id), "0"];
      }
    } else {
      selectedCategories = [...categoryIds].filter(v => v !== "0")
      if (selectedCategories.includes(id)) {
        selectedCategories = selectedCategories.filter(v => v !== id);
      } else {
        selectedCategories = [...selectedCategories, id];
      }
    }

    if (couponCategoriesData?.length === selectedCategories?.length) {
      selectedCategories = [...selectedCategories, "0"];
    }

    dispatch(updateCouponCategoryIds(selectedCategories));
    setIsShowMobileFilter && setIsShowMobileFilter();
  };

  const { theme_type } = useSelector(
    ({ common }) => common.commonDetailsData.header_section || {}
  );

  return (
    <div
      className={`listing-sidebar-sticky-coupon-sidebar ${isMobileView ? "mobile-view" : ""
        }`}
    >
      <h2 className={`${theme_type === "1" ? "" : "h2-theme2"}`}>
        Departments
      </h2>

      <div className="sidebar-item-list">
        <div
          className={`${theme_type === "1"
            ? "ift-item-with-checkbox"
            : "ift-item-with-checkbox-theme2"
            }`}
          key={1}
        >
          <input type="checkbox" id="all" checked={categoryIds.includes("0")} />
          <label htmlFor={"All"} onClick={() => onChangeSelection("0")}>
            <span>{"All Categories"}</span>
          </label>
        </div>
        <div className="spaceDiv"></div>

        {couponCategoriesData?.map((option) => {
            return (
              <>
                <div
                  className={`${theme_type === "1"
                    ? "ift-item-with-checkbox"
                    : "ift-item-with-checkbox-theme2"
                    }`}
                  key={option.product_category_id}
                >
                  <input
                    type="checkbox"
                    id={option.product_category_id}
                    checked={categoryIds.includes(option.product_category_id)}
                  />

                  <label
                    htmlFor={option?.product_category_name
                      ?.split(" ")
                      ?.join("_")
                      ?.toLowerCase()}
                    onClick={() => onChangeSelection(option.product_category_id)}
                  >
                    <span>{option.product_category_name}</span>
                  </label>
                </div>
                <div className="spaceDiv"></div>
              </>
            );
          })}
      </div>
      {!couponDataLoading && bannerAd.length > 0 && (
        <MultiBannerAdSlide el={bannerAd[0]} isSecondaryImage="true" />
      )}
    </div>
  );
};

export default CouponListingPageSidebar;
